<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { APP_LOGO, IS_SAIFTY } from '@/config/customers'

const SHOW_BLANK_PAGE_ON_HOME_REDIRECTION = window.ENV.SHOW_BLANK_PAGE_ON_HOME_REDIRECTION
const size = ref<string>('1rem')

onMounted(() => {
  size.value = '4rem'
})

const iconStyle = computed(() => ({
  height: size.value,
  transition: 'height 1.5s',
}))
</script>

<template>
  <div
    v-if="SHOW_BLANK_PAGE_ON_HOME_REDIRECTION"
    class="text-center w-100 h-100 d-grid justify-content-center align-content-center"
  ></div>
  <div v-else class="text-center w-100 h-100 d-grid justify-content-center align-content-center" :class="IS_SAIFTY ? 'bg-primary' : ''">
    <img :src="APP_LOGO" :class="IS_SAIFTY ? 'white-logo' : ''" :style="iconStyle" alt="Loading..." />
  </div>
</template>

<style scoped></style>
